var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearchIconGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_162608)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3631 14.4699C16.0702 14.177 15.5953 14.177 15.3024 14.4699C15.0095 14.7628 15.0095 15.2377 15.3024 15.5306L16.3631 14.4699ZM18.6356 18.8639C18.9285 19.1568 19.4034 19.1568 19.6963 18.8639C19.9892 18.571 19.9892 18.0961 19.6963 17.8032L18.6356 18.8639ZM15.3024 15.5306L18.6356 18.8639L19.6963 17.8032L16.3631 14.4699L15.3024 15.5306ZM9.16602 15.0835C5.43809 15.0835 2.41602 12.0614 2.41602 8.3335H0.916016C0.916016 12.8898 4.60967 16.5835 9.16602 16.5835V15.0835ZM15.916 8.3335C15.916 12.0614 12.8939 15.0835 9.16602 15.0835V16.5835C13.7224 16.5835 17.416 12.8898 17.416 8.3335H15.916ZM9.16602 1.5835C12.8939 1.5835 15.916 4.60557 15.916 8.3335H17.416C17.416 3.77715 13.7224 0.0834961 9.16602 0.0834961V1.5835ZM9.16602 0.0834961C4.60967 0.0834961 0.916016 3.77715 0.916016 8.3335H2.41602C2.41602 4.60557 5.43809 1.5835 9.16602 1.5835V0.0834961Z",
    fill: "#8F8F8F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_162608"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIconGrey);
export default __webpack_public_path__ + "static/media/searchIconGrey.b379df7f2d7a613fa15a5dc62e96450c.svg";
export { ForwardRef as ReactComponent };